// Will check for query string matching user provided property and scroll to matching value/ID on page load.
// Will attempt to close accordions on page and open only matching one if found.

// To Use: add 'query' property to custom element and set to desired query property name to check for in url and scroll to matching ID on page load. Can also set 'offset' property to set how far from top of page to scroll to element.
// Example URL: https://<base_url>/example-page?product=6024433664155
// Element to scroll to must have data-scroll-to-id attribute with value matching query string value.

// Add to page with this code:
// <script defer src='{{ 'scroll-to-query.js' | asset_url }}'></script>
// <scroll-to-query query="product" offset="90"></scroll-to-query>

// Element on page to scroll to example:
// <div data-scroll-to-id="6024433664155"></div>

class ScrollToQuery extends HTMLElement {
	static DEFAULT_HEADER_OFFSET = 80;
	static ACCORDION_TRANSITION_SPEED = 300;
	static ACCORDION_CLASS_NAME = 'accordion';
	static ACCORDION_ACTIVE_CLASS_NAME = 'accordion--active';
	constructor() {
		super();
		this.addListeners();
	}
	//Check for URL Query strings on page load
	addListeners() {
		window.addEventListener('DOMContentLoaded', this.scrollToID.bind(this));
	}
	//Scrolls to place on page with offset included to avoid top header bar
	smoothScrollTo(scrollHere, offset) {
		//setTimeout allows accordion transition to finish changing DOM before scrolling with offset
		setTimeout(() => {
			window.scrollTo({
				behavior: 'smooth',
				top: scrollHere.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
			});
		}, ScrollToQuery.ACCORDION_TRANSITION_SPEED);
	}
	closeAccordions(parent) {
		const accordions = parent.querySelectorAll(`.${ScrollToQuery.ACCORDION_CLASS_NAME}`);
		if (accordions.length === 0) {
			return;
		}
		accordions.forEach((accordion) => {
			accordion.classList.remove(`.${ScrollToQuery.ACCORDION_ACTIVE_CLASS_NAME}`);
		});
	}
	openAccordion(accordionToOpen) {
		if (accordionToOpen) {
			accordionToOpen.classList.add(`.${ScrollToQuery.ACCORDION_ACTIVE_CLASS_NAME}`);
		}
	}
	//Checks query parameters in url for correct property and scrolls to it if exists
	scrollToID() {
		//Check custom element properties for query property (example: query="product")
		const queryString = this.getAttribute('query');
		if (queryString == null) {
			return;
		}
		const urlParams = new URLSearchParams(window.location.search);
		const urlQuery = urlParams.get(queryString);
		if (urlQuery == null) {
			return;
		}
		//If parent exists with scroll to data attribute on it
		const foundParent = document.querySelector(`[data-scroll-to-id="${urlQuery}"]`);
		if (foundParent == null) {
			return;
		}
		//Set offset of scroll so header doesn't cover element
		const offset = this.getAttribute('offset')
			? parseInt(this.getAttribute('offset'))
			: ScrollToQuery.DEFAULT_HEADER_OFFSET;
		//Scroll to element with matching query ID
		this.closeAccordions(foundParent.parentElement);
		this.openAccordion(foundParent);
		this.smoothScrollTo(foundParent, offset);
	}
}

customElements.define('scroll-to-query', ScrollToQuery);
